import { Theme } from '@mui/material';
import { CSSProperties } from 'react';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const CcfInteractionBodyAccordionStyles = (theme: Theme) => {
  const simStyles = {
  
    accordionContainer: {
      boxShadow: 'none',
      display: 'block',
      background: '#306484',
      margin: '0px !important',
      padding: '0px',
      
    },
  
    accordionHeaderExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: '0px -1px 1px #e7eaec',
    },
    accordionHeader: {
      paddingLeft: '10px',
      borderBottom: '0',
      minHeight: '20px',
      maxHeight: '24px',
      alignItems: 'center',
      display: 'flex',
      margin: '0px !important',
      padding: '0px',
      '&.Mui-expanded': {
        minHeight: '24px'
      }
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
   
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '24px',
      width: '24px',
      color: `rgb(247, 248, 250)`,
    },
   
    setAccordionDetailsItem : {
      padding : '0px',
      background: '#306484',
      minHeight: '45px !important',
      scrollbarWidth: 'none' /* Firefox */
    },

    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },
   
    notesAccordionTitle:{
      fontWeight: '600',
    },
    emailCard:{ display: 'flex', marginTop: '5%', flexWrap: 'wrap' as CSSProperties['flexWrap'], gap :'10px' },
  };
  return simStyles;
};
export default CcfInteractionBodyAccordionStyles;